import { z } from 'zod';

import { BankruptcyId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';
import { BaseLoanEvent } from './BaseLoanEvent';

/**
 * Files (or amends) a Proof of Claim on a bankruptcy. The lender supplies the
 * inputs below; the handler computes the pre/post-petition categorization and
 * escrow deficiencies and appends the result to `bankruptcy.proofOfClaim` —
 * amendments append, and the latest entry is authoritative.
 */
export const CreateBankruptcyProofOfClaimEvent = BaseLoanEvent.extend({
  type: z.literal('createBankruptcyProofOfClaim'),
  bankruptcyId: BankruptcyId,
  petitionFilingDate: zodJSPlainDate,
  dofd: zodJSPlainDate,
});
export type CreateBankruptcyProofOfClaimEvent = z.infer<typeof CreateBankruptcyProofOfClaimEvent>;
